import { useState } from "react";
import {
    Heart,
    Cake,
    Sparkles,
    Wine,
    Camera,
    ChevronDown,
    X,
    Calendar,
} from "lucide-react";
import { SERVICES } from "../lib/data";
import { openWhatsApp } from "../lib/whatsapp";

const ICONS = { Heart, Cake, Sparkles, Wine, Camera };

export default function Pricing() {
    const [open, setOpen] = useState(false);

    const toggle = () => {
        setOpen((v) => {
            const next = !v;
            if (next) {
                setTimeout(() => {
                    const el = document.getElementById("precios-grid");
                    if (el)
                        el.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });
                }, 220);
            }
            return next;
        });
    };

    return (
        <section
            id="precios"
            data-testid="pricing-section"
            className="relative py-14 sm:py-20 bg-[#F3EFE7]"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <div className="text-center max-w-3xl mx-auto reveal">
                    <span className="text-[10px] tracking-[0.4em] uppercase text-[#C4A882]">
                        Sesiones
                    </span>
                    <h2
                        className="font-display text-4xl sm:text-5xl lg:text-6xl font-light text-[#1C1A18] mt-4 leading-[1.1]"
                        data-testid="pricing-title"
                    >
                        Encuentra tu sesión perfecta
                    </h2>
                    <p
                        className="mt-6 text-[#6b665f] font-light"
                        data-testid="pricing-subtitle"
                    >
                        Cada sesión es única y se adapta a ti. Reportajes de
                        boda en Bilbao y la Margen Izquierda. Contáctame y
                        hablamos sin compromiso.
                    </p>
                </div>

                {/* Botón llamativo desplegable */}
                <div className="mt-10 sm:mt-14 flex justify-center reveal reveal-delay-1">
                    <button
                        type="button"
                        onClick={toggle}
                        aria-expanded={open}
                        aria-controls="precios-grid"
                        data-testid="pricing-toggle-btn"
                        className="group relative inline-flex items-center gap-4 px-8 sm:px-12 py-5 sm:py-6 bg-[#1C1A18] text-[#FAFAF8] rounded-full overflow-hidden transition-all duration-500 hover:bg-[#C4A882] hover:text-[#1C1A18] active:scale-95 shadow-2xl"
                    >
                        <Calendar
                            size={20}
                            strokeWidth={1.2}
                            className={`text-[#C4A882] group-hover:text-[#1C1A18] transition-transform duration-500 ${
                                open ? "rotate-180" : ""
                            }`}
                        />
                        <span className="flex flex-col items-start text-left">
                            <span className="text-[9px] sm:text-[10px] tracking-[0.4em] uppercase opacity-70">
                                {open ? "Ocultar sesiones" : "Reserva"}
                            </span>
                            <span className="font-display text-xl sm:text-2xl tracking-wide leading-none mt-1">
                                {open
                                    ? "Cerrar sesiones"
                                    : "Ver tipos de sesión"}
                            </span>
                        </span>
                        {open ? (
                            <X
                                size={20}
                                strokeWidth={1.2}
                                className="text-[#C4A882] group-hover:text-[#1C1A18] transition-colors"
                            />
                        ) : (
                            <ChevronDown
                                size={20}
                                strokeWidth={1.2}
                                className="text-[#C4A882] group-hover:text-[#1C1A18] transition-transform duration-500 group-hover:translate-y-1"
                            />
                        )}
                    </button>
                </div>

                {!open && (
                    <p className="mt-4 text-center text-[10px] tracking-[0.32em] uppercase text-[#9a958c]">
                        {SERVICES.length} sesiones disponibles
                    </p>
                )}

                {/* Grid colapsable */}
                <div
                    id="precios-grid"
                    className={`grid transition-[grid-template-rows,opacity] duration-700 ease-out ${
                        open
                            ? "grid-rows-[1fr] opacity-100 mt-12"
                            : "grid-rows-[0fr] opacity-0 mt-0"
                    }`}
                    aria-hidden={!open}
                >
                    <div className="overflow-hidden">
                        <div
                            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
                            data-testid="pricing-grid"
                        >
                            {SERVICES.map((s) => {
                                const Icon = ICONS[s.icon];
                                return (
                                    <article
                                        key={s.id}
                                        data-testid={`pricing-card-${s.id}`}
                                        className="bg-white p-8 lg:p-10 flex flex-col border-t-[3px] border-[#C4A882] hover:-translate-y-2 transition-transform duration-500"
                                    >
                                        <div className="mb-6 text-[#C4A882]">
                                            {Icon && (
                                                <Icon
                                                    size={28}
                                                    strokeWidth={1}
                                                />
                                            )}
                                        </div>
                                        <h3 className="font-display text-2xl text-[#1C1A18] leading-tight min-h-[60px]">
                                            {s.title}
                                        </h3>
                                        <p className="mt-4 text-sm text-[#6b665f] font-light leading-relaxed flex-grow">
                                            {s.description}
                                        </p>
                                        <button
                                            type="button"
                                            onClick={() =>
                                                openWhatsApp(s.message)
                                            }
                                            data-testid={`pricing-cta-${s.id}`}
                                            className="mt-8 inline-flex items-center justify-center text-[11px] uppercase tracking-[0.22em] text-[#1C1A18] link-underline self-start"
                                        >
                                            {s.cta} →
                                        </button>
                                    </article>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
